import {
  formatRecordingIdDateParts,
  parseTimestampFromRecordingId,
} from "../../utils/results/recordingIdTime";
import {
  pickSpirometryResult,
  SPIROMETRY_PREDICTION_SOURCES,
} from "../../utils/results/spirometry";
import { buildSnapshotSubset } from "./readSnapshotField";

export const SPIROMETRY_LIST_FIELDS = [
  "createdAt",
  "takenAt",
  "submittedAt",
  "completedAt",
  "Signal_Quality",
  "signal_quality",
  "results.mpm.rr_avg",
  "results.mpm.rr_mean",
  "results.mpm.rr_median",
  "results.mpm.rr_min",
  "results.mpm.rr_max",
  "results.mpm.respiratory_rate",
  "results.mpm.flow_loop.quality_status",
  "results.mpm.flow_loop.quality",
  "results.mpm.spirometry",
  "results.mpm_signal_quality",
  "results.mpm_spiro_signal_quality",
  "results.mpm.mpm_signal_quality",
  "results.mpm.mpm_spiro_signal_quality",
];

export function mapSpirometryDocToRow(
  doc,
  languageFallback = "en-GB",
  {
    predictionSource = SPIROMETRY_PREDICTION_SOURCES.LUNGDX,
  } = {},
) {
  const data = buildSnapshotSubset(doc, SPIROMETRY_LIST_FIELDS);
  const ts = parseTimestampFromRecordingId(doc.id);
  const { time, date } = formatRecordingIdDateParts(doc.id, languageFallback);
  const {
    fev1,
    fvc,
    fev1FvcRatio,
    pef,
    rr,
    signalQuality,
    spirometryQuality,
    additionalMetrics,
  } = pickSpirometryResult(data, { predictionSource });

  const row = {
    id: doc.id,
    timestamp: ts ? ts.toISOString() : null,
    time,
    date,
    fev1,
    fvc,
    fev1FvcRatio,
    pef,
    rr: rr?.average ?? rr?.mean ?? null,
    meanExhaleInhaleAreaRatio:
      additionalMetrics?.meanExhaleInhaleAreaRatio ?? null,
    signalQuality,
    spirometryQuality,
  };

  ["createdAt", "takenAt", "submittedAt", "completedAt"].forEach((field) => {
    if (data?.[field] !== undefined && data?.[field] !== null) {
      row[field] = data[field];
    }
  });

  return row;
}
